import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";
import SubmitPage from "@/pages/SubmitPage";
import SubmitSuccessPage from "@/pages/SubmitSuccessPage";
import LoginPage from "@/pages/LoginPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "sonner";

function App() {
    return (
        <div className="App">
            <Toaster theme="dark" position="bottom-right" />
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/submit" element={<SubmitPage />} />
                        <Route
                            path="/submit/success"
                            element={<SubmitSuccessPage />}
                        />
                        <Route path="/login" element={<LoginPage />} />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute>
                                    <AdminPage />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
